"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _omit = _interopRequireDefault(require("transmute/omit"));

var _translate = _interopRequireDefault(require("transmute/translate"));

var _classnames = _interopRequireDefault(require("classnames"));

var _immutable = require("immutable");

var _PropertyRecord = _interopRequireDefault(require("customer-data-objects/property/PropertyRecord"));

var _SyntheticEvent = _interopRequireDefault(require("UIComponents/core/SyntheticEvent"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _propertyTranslator = require("property-translator/propertyTranslator");

var defaultProps = {
  value: ''
};
var MULTI_VALUE_SEPARATOR_REGEX = /; ?/;
var propTypes = {
  className: _react.PropTypes.string,
  defaultValue: _react.PropTypes.node,
  isInline: _react.PropTypes.bool.isRequired,
  onFocus: _react.PropTypes.func,
  onBlur: _react.PropTypes.func,
  onChange: _react.PropTypes.func.isRequired,
  showPlaceholder: _react.PropTypes.bool,
  property: _react.PropTypes.instanceOf(_PropertyRecord.default).isRequired,
  value: _react.PropTypes.string
};

var PropertyInputEnumMulti =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(PropertyInputEnumMulti, _React$Component);

  function PropertyInputEnumMulti() {
    var _this;

    (0, _classCallCheck2.default)(this, PropertyInputEnumMulti);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PropertyInputEnumMulti).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.partial = (0, _ComponentMethods.makePartial)();
    return _this;
  }

  (0, _createClass2.default)(PropertyInputEnumMulti, [{
    key: "focus",
    value: function focus() {
      this.refs.input.focus();
    }
  }, {
    key: "handleChange",
    value: function handleChange(evt) {
      var onChange = this.props.onChange;
      onChange((0, _SyntheticEvent.default)(evt.target.value.join(';')));
    }
  }, {
    key: "getOptions",
    value: function getOptions(property) {
      var hubspotDefined = property.get('hubspotDefined');
      var options = property.get('options');
      return options.map((0, _translate.default)({
        text: function text(option) {
          if (hubspotDefined && option.get('readOnly')) {
            return (0, _propertyTranslator.propertyLabelTranslator)(option.get('label'));
          }

          return option.get('label');
        },
        value: true
      }));
    }
  }, {
    key: "getOptionsWithSelected",
    value: function getOptionsWithSelected(selectedValues) {
      var property = this.props.property;
      var optionsSeq = this.getOptions(property);
      var selectOptions = optionsSeq.toJS();

      if (selectedValues.length) {
        var propertyValidOptions = property.get('options').map(function (option) {
          return option.value;
        });
        var invalidValueSelectOptions = selectedValues.filter(function (val) {
          return !propertyValidOptions.includes(val);
        }).map(function (val) {
          return {
            text: val,
            value: val,
            tagUse: 'candy-apple'
          };
        });
        return selectOptions.concat(invalidValueSelectOptions);
      }

      return selectOptions;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isInline = _this$props.isInline,
          value = _this$props.value;
      var valueProp = value !== '' ? value.split(MULTI_VALUE_SEPARATOR_REGEX).filter(function (val) {
        return val !== '';
      }) : '';
      var transferableProps = (0, _omit.default)(['error', 'isInline', 'getProperty', 'objectType', 'onCancel', 'onInvalidProperty', 'propertyIndex', 'readOnlySourceData', 'showError', 'subject', 'subjectId', 'secondaryChanges', 'onSecondaryChange', 'onTracking', 'isRequired'], (0, _immutable.Seq)(this.props)).toJS();

      if (!isInline) {
        transferableProps.use = 'form';
      }

      return _react.default.createElement(_UISelect.default, (0, _extends2.default)({}, transferableProps, {
        onChange: this.handleChange,
        className: (0, _classnames.default)('PropertyInputEnumMulti', this.props.className),
        multi: true,
        anchorType: "button",
        options: this.getOptionsWithSelected(valueProp),
        placeholder: this.props.property.placeholder || '',
        ref: "input",
        value: valueProp
      }));
    }
  }]);
  return PropertyInputEnumMulti;
}(_react.default.Component);

exports.default = PropertyInputEnumMulti;
PropertyInputEnumMulti.propTypes = propTypes;
PropertyInputEnumMulti.defaultProps = defaultProps;
module.exports = exports.default;